import type { IComment } from "../../types/comment";
import type { IImage } from "../../types/image";
import { updateCommentLikes } from "./commentHelper";

// Updates the likes on an image //
export const updateImageLikes = (images: IImage[], username: string) => {
    return images.map((img, imgIndex) => {
        if (imgIndex !== 0) return img;

        const alreadyLiked = img.likes.includes(username);

        let newLikes = img.likes;

        if (!alreadyLiked) {
            newLikes = [...img.likes, username];
        } else if (alreadyLiked) {
            newLikes = img.likes.filter((u) => u !== username);
        }

        return {
            ...img,
            likes: newLikes,
        };
    });
};

export const updateImageBoxData = (
    images: IImage[],
    currentImageIndex: number,
    type: "likes" | "commentText" | "commentLike",
    username: string,
    comment?: IComment,
    commentId?: string
) => {
    const newImages =
        type === "likes"
            ? updateImageLikes(images, username)
            : images.map((img, imgInd) => {
                  if (imgInd !== currentImageIndex) return img;

                  const newComments =
                      type === "commentText" ? [...img.comments, comment!] : updateCommentLikes(img.comments, username, commentId!);

                  return { ...img, comments: newComments };
              });

    return newImages;
};
